module.exports = __webpack_public_path__ + "img/w3_cart_grey.231d891f.png";